import { useHistory, useParams } from "react-router-dom";
import { ButtonCustom, CancelButton } from "../../shared/Style/Style";
import { ButtonsWrapper } from "../styles";

export const TrainerFormButtons = ({isPublished, canPublish, onPublish} : { isPublished: boolean, canPublish: boolean, onPublish: () => void }) => {
    const { push } = useHistory();
    const { appId, trainerId } = useParams<{ appId: string, trainerId: string }>();
    
    return (
        <ButtonsWrapper>
            <CancelButton
                type="button"
                onClick={() => push(`/mobileApps/${appId}/trainers`)}
            >
                Закрити
            </CancelButton>
            <ButtonCustom type="submit">Зберегти</ButtonCustom>
            {trainerId && <ButtonCustom
                type="button"
                disabled={!canPublish}
                onClick={onPublish}
                width={isPublished && "100%"}
            >
                {isPublished ? "Оновити публікацію" : "Опубліковати"}
            </ButtonCustom>}
        </ButtonsWrapper>
    );
};
